import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item_action = _resolveComponent("v-list-item-action")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_divider, {
      class: "mr-2 ml-2",
      vertical: ""
    }),
    (_ctx.loaded)
      ? (_openBlock(), _createBlock(_component_v_menu, {
          key: 0,
          "close-on-content-click": true
        }, {
          activator: _withCtx(({ props }) => [
            _createVNode(_component_v_btn, _mergeProps({
              icon: "",
              variant: "text"
            }, props, {
              class: "mr-1",
              style: {"height":"36px","width":"36px"}
            }), {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, null, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                    _createTextVNode("mdi-account", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _: 1
            }, 16)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_v_list, null, {
              default: _withCtx(() => [
                (_ctx.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 0,
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changePassword()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-lock-reset", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.changePassword")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 1,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.signOut()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createTextVNode("mdi-account", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.logout")) + " " + _toDisplayString(_ctx.account.name), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (!_ctx.isAuthenticated)
                  ? (_openBlock(), _createBlock(_component_v_list_item, {
                      key: 2,
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.signIn()))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item_action, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-account", -1)
                              ]))]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createElementVNode("div", null, [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t("message.login")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}